module.exports = __webpack_public_path__ + "img/fogg-message-sent.33ed7638.png";